import { observer } from "mobx-react-lite";
import { Navigate, useLocation } from "react-router-dom";
import { authStore } from "@/store/auth";

const PrivateRoute = ({ children }) => {
  const location = useLocation();

  if (!authStore.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  return children;
};

export default observer(PrivateRoute);
